import { useAppSelector } from '@/store/hooks';
import { getWorkingProjectSessions, getWorkingProjectUuid } from '@/store/slices/project/selectors';
import { selectThemePacks } from '@/store/slices/templates/selectors';
import OptionalComponent from '@ui/optional-component/optional-component';
import useBlockNavigationWhileSavingProject from './use-block-navigation-while-saving-project';
import OverviewSingleSession from './layouts/overview-single-session/overview-single-session';
import OverviewMultiSession from './layouts/overview-multi-session/overview-multi-session';
import UpdateProjectTypeModal from './components/update-project-type/update-project-type-modal';
import BrandedLoadingIndicator from '@/components/branding/branded-loading-indicator';

const ProjectOverview = () => {
  const _sessions = useAppSelector(getWorkingProjectSessions);
  const workingProjectUuid = useAppSelector(getWorkingProjectUuid);
  const themePacks = useAppSelector(selectThemePacks);

  useBlockNavigationWhileSavingProject();

  const sessions = _sessions || [];

  const isSingleSession = sessions.length === 1;
  const isMultiSession = sessions.length > 1;

  if (!workingProjectUuid) {
    return null;
  }
  if (!themePacks) {
    return (
      <OptionalComponent display delayRender={500}>
        <BrandedLoadingIndicator />
      </OptionalComponent>
    );
  }
  if (!workingProjectUuid) return null;
  return (
    <div data-component="ProjectOverview">
      <OptionalComponent display={isSingleSession}>
        <OverviewSingleSession />
      </OptionalComponent>

      <OptionalComponent display={isMultiSession}>
        <OverviewMultiSession />
      </OptionalComponent>

      <UpdateProjectTypeModal />
    </div>
  );
};

export default ProjectOverview;
